import { render } from "./VoyagesResume.vue?vue&type=template&id=08ac3c27"
import script from "./VoyagesResume.vue?vue&type=script&lang=js"
export * from "./VoyagesResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__